import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import FormControl from 'react-bootstrap/FormControl';

import InputWrapper from '../input-wrapper';

/**
 * Putting the onChange in the FormGroup instead of on FormControl throws react error
 * * You provided a `value` prop to a form field without an `onChange` handler.
 * * This will render a read-only field. If the field should be mutable use `defaultValue`.
 * * Otherwise, set either `onChange` or `readOnly`.
 */

/**
 * `as` may only carry 'textarea' — any other `type` belongs on the native
 * input element; passing it through `as` renders a non-editable custom
 * element (e.g. <text>). File inputs cannot be controlled, so they never
 * receive `value`.
 * @param {object} props
 * @return {object}
 */
export const InputType = (props) => {
    const errorId = props.id ? `${props.id}-error` : null;
    const typeProps = props.type === 'textarea' ? { as: 'textarea' } : { type: props.type };
    const controlProps = R.omit(['error', 'label', 'type', 'value'], props);

    return props.type === 'date' ? (
        <div>Use DatePicker for date types ({props.value})</div>
    ) : (
        <InputWrapper {...R.pick(['label', 'error'], props)} errorId={errorId}>
            <FormControl
                {...controlProps}
                {...typeProps}
                {...(props.type !== 'file' && { value: props.value || '' })}
                {...(props.error && { 'aria-invalid': 'true', 'aria-describedby': errorId })}
                isInvalid={!!props.error}
            />
        </InputWrapper>
    );
};

InputType.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    options: PropTypes.array,
};
